
import { Component, Prop, Vue } from "vue-property-decorator";
import { Modal } from "ant-design-vue";
@Component
export default class Paidinfo extends Vue {
  private data = [
    {
      title: "房地产金融化泡沫化势头得到遏制",
      url:
        "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3080557229,989169363&fm=26&gp=0.jpg",
      content:
        "中国人民银行党委书记、中国银保监会主席郭树清日前在《求是》杂志撰文指出，新冠肺炎疫情发生后金融领域出现新的重大挑战，金融系统要努力确保经济社会发展目标如期实现，现阶段的重要工作包括全力推动国民经济恢复正常循环，加快金融供给侧结构性改革，进一步加..."
    },
    {
      title: "拿地四年后赔本销售 这的地王将入市",
      url:
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597677129877&di=c44aaf73f833a1b1c55dc15854621ab8&imgtype=0&src=http%3A%2F%2Fsimages1.juwaistatic.com%2Fauto%2F740x540%2Fstore-x%2Ff59f52c79f78b9fb695c1fc6840f1f20-e951ec2bbe7eca351899a0704268fa78.jpg",
      content:
        "在全国楼市中，厦门可以说是一个“低调”但又不容忽视的城市。镁编获悉，厦门本地国企下属的厦门海投房地产有限公司（以下简称“海投房产”）在2016年底拿下的一宗岛外地王预计将于8月15日入市销售。在8月5日，该项目拿到了首批预售证，均价在..."
    },
    {
      title: "央行：LPR改革带动存款利率下行",
      url:
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597677167868&di=536c4d1c5da778d282e533bf767c54c3&imgtype=0&src=http%3A%2F%2Fres.dyhjw.com%2Fueditor%2Fphp%2Fupload%2Fimage%2F20170526%2F1495770496111755.jpg",
      content:
        "8月6日，央行发布《2020年第二季度中国货币政策执行报告》（以下简称“报告”）。报告显示，今年以来，人民银行完善结构性货币政策工具体系，精准滴灌。代表性的货币市场基金收益率也已降至1.5％以下，低于1年期存款基准利率..."
    },
    {
      title: "不寻常信号！房产贷款23个月回落",
      url: "https://inews.gtimg.com/newsapp_bt/0/12297444747/1000",
      content:
        "据7月31日央行发布的2020年二季度金融机构贷款投向统计报告，今年上半年，金融机构人民币各项贷款余额165.2万亿元，同比增长13.2％；上半年增加12.09万亿元，同比多增2.42万亿元。房地产的“吸金”能力削弱了..."
    },
    {
      title: "二手房买卖猫腻多，这篇文章告诉你都该注意什么",
      url:
        "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1597677423637&di=bbd051deca6b54fa8cef1adef7e6d4b7&imgtype=0&src=http%3A%2F%2Fb.hiphotos.baidu.com%2Fexp%2Fw%3D500%2Fsign%3D7b8503a6c895d143da76e42343f18296%2F2f738bd4b31c870198a95d43277f9e2f0708ff7c.jpg",
      content:
        "大多数年轻人的目标都是买一套房子，但是这个目标是越来越难实现了，主要就是由于房价很贵，但是有很多80后90后，现在是急需要房子的，而且现在的人都比较现实，如果没有房子的话，结婚是比较困难的，当我们没有过多的资..."
    }
  ];
  // https://imgdwcs.soufunimg.com/2020/08/14/2000k/34958562985248099dafef14ff79f0c1.jpg
  render() {
    return (
      <div class="paid-info">
        <div class="banner">
          <div class="banner-declaration"></div>
        </div>
        <div style="height:40px;"></div>
        <h2 class="title">有偿资讯</h2>
        <div class="inner-content">
          {this.data.map((item, idx) => (
            <div key={idx} class="info">
              <img src={item.url} />
              <div class="ct">
                <h3 class="title">{item.title}</h3>
                <div class="subtitle">{item.content}</div>
                <div class="time">发布时间：2020-04-04</div>
              </div>
              <div class="money">1元/条</div>
              <div class="btn">
                <a-button
                  type="danger"
                  onClick={() => {
                    Modal.success({
                      icon: "",
                      okText: "确认",
                      cancelText: "取消",
                      content: (
                        <div>
                          <div style="height:20px;"></div>
                          <img
                            width="200"
                            src={require("@/assets/abbbb71d36f6943e10b46c8ccea2645c.png")}
                          />
                          <div style="height:20px;padding-left:120px;">
                            微信扫描
                          </div>
                        </div>
                      ),
                      onOk() {
                        return new Promise((resolve, reject) => {
                          resolve();
                        }).catch(() => console.log("Oops errors!"));
                      },
                      onCancel() {
                        Modal.destroyAll();
                      }
                    });
                  }}
                >
                  付费阅读
                </a-button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}
